import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import '../../styles/styleInput/inputStyle.css';

export const GenericAutocomplete = ({
    options,
    value,
    label,
    name,
    onChange,
    onBlur,
    inputRef = null,
    required = false,
    error = false,
    helperText = '',
    disabled = false,
    disableCloseOnSelect = true
}) => {
    return (
        <Autocomplete
            options={options}
            getOptionLabel={(option) => option.name || ''}
            value={options.find((item) => String(item.code) === String(value)) || null}
            isOptionEqualToValue={(option, val) => String(option.code) === String(val.code)}
            disableCloseOnSelect={disableCloseOnSelect}
            disabled={disabled}
            onChange={(event, newValue) => {
                onChange({
                    target: {
                        name,
                        value: newValue?.code ?? '',
                        label: newValue?.name ?? '',
                        fullObject: newValue ? { ...newValue } : {}
                    }
                });
            }}
            onBlur={(event) => {
                onBlur?.(event);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    name={name}
                    error={error}
                    helperText={error ? helperText : ''}
                    required={required}
                    inputRef={inputRef}
                    className='GenericAutoCompleteSelect'
                    sx={{
                        '.MuiInputBase-root': {
                            height: '38px',
                        },
                        '.MuiInputLabel-root': {
                            lineHeight: '10px',
                        }
                    }}
                />
            )}
        />
    );
};